import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import WhyChooseUs from './pages/WhyChooseUs';
import Services from './pages/Services';
import Clients from './pages/Clients';
import Careers from './pages/Careers';
import Gallery from './pages/Gallery';
// import './styles.css';
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path='/why-choose-us' element={<WhyChooseUs />} />
        <Route path='/services' element={<Services />} />
        <Route path='/clients' element={<Clients />} />
        <Route path='/career' element={<Careers />} />
        <Route path='/gallery' element={<Gallery />} />
        <Route path='/contact-us' element={<Contact />} />

        {/* Handle unmatched routes */}
        {/* <Route path="*" element={<Navigate to="/" />} /> */}
      </Routes>
    </Router>
  );
}

export default App;
